var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"100%"},attrs:{"to":{
		name: 'course-section',
		params: {
			courseSectionId: _vm.courseSection.id,
		},
	},"elevation":"24","outlined":"","dark":""}},[_c('v-card-title',[_c('v-icon',{staticClass:"mr-4"},[_vm._v("mdi-folder")]),_vm._v(" "+_vm._s(_vm.courseSection.name)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }